import React from "react";
import "./ClusterMarker.css";

const ClusterMarker = ({ pointCount, onClick }) => {
  // Dynamic sizing based on point count
  const getSize = () => {
    if (pointCount < 10) return 36;
    if (pointCount < 25) return 42;
    if (pointCount < 50) return 48;
    return 54;
  };

  const size = getSize();

  return (
    <div
      className="cluster-marker"
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      onClick={onClick}
    >
      <span className="cluster-marker-count">{pointCount}</span>
    </div>
  );
};

export default ClusterMarker;

